import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET } from './api';
import mapShopDashboardData from '../../mappers/dashboardMappers';
import { selectAvailableMarkets } from '../../selectors/market/market';
import type { RootState } from '../..';

export const getShopDashboard = createAsyncThunk(
  'shopDashboard/getShopDashboard',
  async (_, thunkAPI) => {
    const { dispatch, getState } = thunkAPI;
    const state = getState() as RootState;

    const dashboardResult = await dispatch(
      GET({
        path: `/rrm-rc/shops-dashboard`,
        label: `Get Shop Dashboard`,
      }),
    );

    // Get markets from selector/store
    const markets = selectAvailableMarkets(state);
    // Create a map of market codes to market data
    const marketsMap = Object.fromEntries(
      (markets ?? []).map((market) => [market.retailUnit, market]),
    );
    const data = mapShopDashboardData(dashboardResult, marketsMap);
    return data;
  },
);
